import { AbstractControl } from '@angular/forms';

export type CustomFormStatus =
  | 'custom-default'
  | 'custom-disabled'
  | 'custom-valid'
  | 'custom-invalid';
export function getStatusClass(form: AbstractControl) {
  if (form.disabled) {
    return 'custom-disabled';
  }
  if (form.valid) {
    const value = form.value;
    // An empty response is not strictly invalid, but not valid neither...
    return value !== undefined && value !== null
      ? 'custom-valid'
      : 'custom-default';
  }
  if (form.touched) {
    return 'custom-invalid';
  }
  // Invalid but not touched yet
  return 'custom-default';
}

function _scrollTo(el: HTMLElement, arg?: boolean | ScrollIntoViewOptions) {
  const bounding = el.getBoundingClientRect();
  if (
    bounding.top < 0 ||
    bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight)
  ) {
    el.scrollIntoView(arg);
  }
}

export function scrollTo(
  el: HTMLElement,
  arg?: boolean | ScrollIntoViewOptions
) {
  _scrollTo(el, arg);

  // Wait some time as a focus may show a keyboard
  setTimeout(() => _scrollTo(el, arg), 1000);
}

// Custom slow scroll function
export function slowScrollTo(element: HTMLElement, duration = 2500) {
  // Get the element's position relative to the viewport
  const elementPosition = element.getBoundingClientRect().top;
  // Get starting position (current scroll position)
  const startPosition = window.pageYOffset;
  // Calculate distance to scroll
  const distance = elementPosition;

  let startTime: number | null = null;

  function animation(currentTime: number) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const scrollY = easeInOutCubic(
      timeElapsed,
      startPosition,
      distance,
      duration
    );

    window.scrollTo(0, scrollY);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  // Easing function for smooth acceleration and deceleration
  function easeInOutCubic(t: number, b: number, c: number, d: number) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t * t + b;
    t -= 2;
    return (c / 2) * (t * t * t + 2) + b;
  }

  requestAnimationFrame(animation);
}
